import React, { useEffect, useState } from 'react';
import { observer } from "mobx-react";
import { ShowableProductCard } from "ReactApp/Ddd/Aggregates/ShowableProductCard";

type ShareV1Props = {
    productCard: ShowableProductCard
}

// Для быстроты забираю уже отрендеренный виджет и рендерю 1 раз
const element = document.querySelector('.share-v1');
const staticHTML = element ? element.outerHTML : '';
const ShareV1 = observer(({productCard}: ShareV1Props) => {
    let { currentProductConfig } = productCard;

    if (!currentProductConfig) {
        return <div>Загрузка...</div>;
    }
    const uniqueKey = currentProductConfig.getUniqueId();
    // переинициализация виджета с зависимостью от модификатора
    useEffect(() => {
            window?.widgets?.shareV1?.reInit();
        },
        [uniqueKey]
    );
    return (
        <div dangerouslySetInnerHTML={{__html: staticHTML}} key={uniqueKey} />
    );
})

export { ShareV1 };
